import { Action } from 'redux';
import * as actions from './actions';
import User from '@common/types/user/user';

export class SetActiveProfile implements Action {
  readonly type = actions.SET_ACTIVE_PROFILE;

  constructor(public isArtist: boolean, public id: string) {}
}

export class SetUserToActiveProfile implements Action {
  readonly type = actions.SET_USER_TO_ACTIVE_PROFILE;

  constructor(public user: Partial<User>) {}
}

export type ActiveProfileActions = SetActiveProfile | SetUserToActiveProfile;
